<template>
<div class="chapter">
<div class="inner_page">
<p class="chaptitlea"><a id="page_v"></a><strong>Contents</strong></p>
<p class="toc"><a href="#/04_foreword#for"><em>Foreword by Dr. Frank P. Varney</em></a></p>
<p class="toc"><a href="#/05_acknowledgements#ack"><em>Acknowledgements</em></a></p>
<p class="toc"><a href="#/06_text#tex"><em>A Note on the Text</em></a></p>
<p class="tocb"><a href="#/07_introduction#int"><em>Introduction: The Vanishing of Vincent</em></a></p>
<p class="toc-chap"><a href="#/08_chapter_01#ch1"><span class="chap">1</span> The Strongs and the Vincents: Early Life, Education, and Courtship</a></p>
<p class="toc-chap"><a href="#/09_chapter_02#ch2"><span class="chap">2</span> Lieutenant Vincent of the Erie Regiment: January to August 1861</a></p>
<p class="toc-chap"><span href="#/10_chapter_03#ch3" title="Link target outside of Sample"><span class="chap">3</span> The 83rd Pennsylvania: August 1861 to March 1862</span></p>
<p class="toc-chap"><span href="#/11_chapter_04#ch4" title="Link target outside of Sample"><span class="chap">4</span> The Swamps of the Chickahominy: Late March to September 1862</span></p>
<p class="toc-chap"><span href="#/12_chapter_05#ch5" title="Link target outside of Sample"><span class="chap">5</span> Colonel Vincent: October 1862 to January 1863</span></p>
<p class="toc-chap"><span href="#/13_chapter_06#ch6" title="Link target outside of Sample"><span class="chap">6</span> “I Enlisted to Fight”: January to April 1863</span></p>
<p class="toc-chap"><span href="#/14_chapter_07#ch7" title="Link target outside of Sample"><span class="chap">7</span> “I Wish He Were a Brigadier-General”: May to June 1863</span></p>
<p class="toc-chap"><span href="#/15_chapter_08#ch8" title="Link target outside of Sample"><span class="chap">8</span> March to Mortality: July 1, 1863</span></p>
<p class="toc-chap"><span href="#/16_chapter_09#ch9" title="Link target outside of Sample"><span class="chap">9</span> The Lion of Round Top: July 2, 1863</span></p>
<p class="toc-chap"><span href="#/17_chapter_10#ch10" title="Link target outside of Sample"><span class="chap">10</span> The Road to Immortality: July 3 to July 7, 1863</span></p>
<p class="toc-chap"><span href="#/18_chapter_11#ch11" title="Link target outside of Sample"><span class="chap">11</span> The Path to Being Forgotten: The Legacy of Strong Vincent</span></p>
<p class="toct"><span href="#/19_appendix#app" title="Link target outside of Sample"><em>Appendix: The Origins of the “Chamberlain Myth”</em></span></p>
<p class="toc"><span href="#/20_bibliography#bib" title="Link target outside of Sample"><em>Bibliography</em></span></p>
<p class="toc"><span href="#/21_notes#not" title="Link target outside of Sample"><em>Notes</em></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 02_contents.vue?6f101daa